/**
 * Link to CRM settings (hub admin only)
 */

import React from 'react'
import { Link } from 'react-router-dom'
import { useSchedulerAuth } from '../../../contexts/SchedulerAuthContext'
import { HUB_GROUPS, getUserGroupNames, isHubSuperAdmin } from '../../../constants/hub-groups'

function isHubCrmAdmin(user) {
  if (!user) return false
  if (isHubSuperAdmin(user)) return true
  return getUserGroupNames(user).includes(HUB_GROUPS.HUB_ADMIN)
}

export default function CrmSettingsLink({ className = '' }) {
  const { user } = useSchedulerAuth()
  if (!isHubCrmAdmin(user)) return null

  return (
    <Link
      to="/hub/crm/settings"
      className={`inline-flex items-center gap-1.5 text-sm font-medium text-gray-700 hover:text-green-800 hover:underline focus:outline-none focus:underline ${className}`}
    >
      <svg
        className="size-4 shrink-0"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
      Settings
    </Link>
  )
}

export { isHubCrmAdmin }
